module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "free-term-confirmation"
    }
  }, [(_vm.$store.patient.has_reservation_permission) ? [_c('div', {
    staticClass: "section-name-default"
  }, [_vm._v("Wybrany termin wizyty")]), _vm._v(" "), _c('free-term', {
    attrs: {
      "free-term": _vm.freeTerm,
      "type": _vm.TYPES.CHOSEN
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "note-container"
  }, [_c('button', {
    staticClass: "btn-solid-green btn-large btn-confirm",
    on: {
      "click": _vm.confirmFreeTermWrapper
    }
  }, [_vm._v("\n                POTWIERDŹ I ZAREZERWUJ TERMIN\n            ")])])] : _c('div', {
    attrs: {
      "id": "no-reservation-permission"
    }
  }, [_c('h1', {
    staticClass: "warn"
  }, [_vm._v("Rezerwacja zablokowana!")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v(" " + _vm._s(_vm.warnInfo))]), _vm._v(" "), _c('button', {
    staticClass: "btn-outline-blue",
    on: {
      "click": _vm.goToPatientsPortal
    }
  }, [_vm._v("PRZEJDŹ DO SWOJEGO KONTA")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-89080c42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FreeTermConfirmation.vue
// module id = 210
// module chunks = 0